export const environment = {
  name: 'dev-us1',
  production: true,
  apiClientId: '432oubb670s3el0t8s154kq1r',
  userPoolId: 'us-east-1_YywI82CLj',
  graphqlEndpoint:
    'https://flccaqkforb3fo6t5wuy7425la.appsync-api.us-east-1.amazonaws.com/graphql',
  graphqlApiKey: 'da2-ywqrxu632rcr3j6ckj2y6wqk7i',
}
